import { Button, Input } from '@chakra-ui/react';
import React from 'react';
import { useForm } from 'react-hook-form';
import CommonSectionTitle from '../../../App/Components/CommonSectionTitle';
import useGeneralStore from '../../../App/Store/GeneralStore';
import RightContentMap from '../../components/RightContentMap';

const ResetPassFormHook = () => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = data => console.log(data);
    const { isDarkMode } = useGeneralStore();

    return (
        <div className='md:flex'>
            <div className='px-1 pb-10'>
                <RightContentMap />
            </div>

            <div className='md:w-[70%] bg-gray-100 text-gray-800 dark:bg-cDarkBG2 rounded-lg shadow-lg p-5'>
                <CommonSectionTitle
                    title='Reset Password using react form hook'
                    withBackLink={true}
                    backLinkUrl='/play'
                />
                <form onSubmit={handleSubmit(onSubmit)} className='pt-5' >

                    <Input type={'password'} variant='flushed' placeholder='Old Password'
                        {...register("old_password", {
                            required: true,
                            minLength: {
                                value: 5, message: ": minimum length: 5 chars"
                            },
                            maxLength: {
                                value: 12, message: ": maximum length: 12 chars"
                            }
                        })} />
                    {errors.old_password && <div>Old Password is required{errors.old_password.message}</div>}

                    <Input type={'password'} variant='flushed' placeholder='New Password'
                        {...register("new_password", {
                            required: true,
                            validate: (value, formValues) => value !== formValues.old_password || ': New Password should not match the old one!',
                            minLength: {
                                value: 5, message: ": minimum length: 5 chars"
                            },
                            maxLength: {
                                value: 12, message: ": maximum length: 12 chars"
                            }
                        })} />
                    {errors.new_password && <div>New Password is required{errors.new_password.message}</div>}

                    <Input type={'password'} variant='flushed' placeholder='Repeat New Password'
                        {...register("repeat_new_password", {
                            required: true,
                            validate: (value, formValues) => value === formValues.new_password || ': Repeat password must match New password',
                            minLength: {
                                value: 5, message: ": minimum length: 5 chars"
                            },
                            maxLength: {
                                value: 12, message: ": maximum length: 12 chars"
                            }
                        })} />
                    {errors.repeat_new_password && <div>Repeat New Password is required{errors.repeat_new_password.message}</div>}

                    <div className="pt-5">
                        <Button type='submit' variant={'outline'}
                         colorScheme={isDarkMode ? '' : 'blackAlpha'} 
                         >Save All</Button>
                    </div>

                </form>
            </div>
        </div>

    )
}

export default ResetPassFormHook